import { CategoryOption } from "./type";

export const categoryOptions: CategoryOption[] = [
    { value: 'AppDevelopment', label: 'App Development' },
    { value: 'WebDevelopment', label: 'Web Development' },
    { value: 'GraphicDevelopment', label: 'Graphic Development' },
    { value: 'AIAutomation', label: 'AI & Automation' },
    { value: 'Fintech', label: 'Fintech' },
];